import { observer } from 'mobx-react';
import ShipmonkCredentialsStore from "../../../stores/credentials/shipmonk-credentials-store";
import {IValidationGroup} from "../../../../../../hooks/validation-group/validation-group-hook";
import {FormFieldLine} from "../../../../../../components/form-field-line/form-field-line";
import {Input} from "../../../../../../components/inputs/input/input";
import {IOption, SelectDropdown} from "../../../../../../components/inputs/select-dropdown/select-dropdown";

interface IProps {
    credentialsStore: ShipmonkCredentialsStore,
    vGroup: IValidationGroup,
}

const ShipmonkCredentials: React.FC<IProps> = observer(({
    credentialsStore, vGroup
}) => {
    const warehouseOptionsList: IOption[] = credentialsStore.getWarehouseOptionsList();
    const selectedWarehouse: IOption | undefined = warehouseOptionsList.find(warehouse => warehouse.value === credentialsStore.warehouse);
    const onWarehouseSelect = (warehouse: IOption) => {
        credentialsStore.warehouse = warehouse.value as string;
    };

    return (
        <>
            <FormFieldLine
                required
                label='Store ID'
                key='store_id'
                note={'Shipmonk store ID'}
            >
                <Input
                    value={credentialsStore.storeId}
                    onChange={credentialsStore.setStoreId}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Warehouse code'
                key='warehouse'
                note={'Shipmonk warehouse'}
            >
                <SelectDropdown
                    options={warehouseOptionsList}
                    value={selectedWarehouse}
                    onChange={v => onWarehouseSelect(v as IOption)}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Shipmonk Api Key'
                key='api_key'
                note='Api token for this account'
            >
                <Input
                    value={credentialsStore.apiKey}
                    onChange={credentialsStore.setApiKey}
                    required
                    autoComplete='new-password'
                    type='password'
                />
            </FormFieldLine>
        </>
    );
});

export default ShipmonkCredentials;
